import { Component } from "@angular/core";
import { NewUiButton } from "@ankaadia/ankaadia-shared-frontend";
import { ConfirmDialog } from "primeng/confirmdialog";
import { TranslateDirective } from "../transloco/translate.directive";

@Component({
  selector: "new-ui-global-confirmation",
  templateUrl: "./new-ui-global-confirmation.component.html",
  imports: [TranslateDirective, ConfirmDialog, NewUiButton],
})
export class NewUiGlobalConfirmationComponent {}
